import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseService } from "../../core/base.service";

/**
 * 班级实体（对应后端 class 表；实际表名建议 class_info / grade_class，见 ADR-002）
 */
export interface ClassEntity {
  /** 主键ID */
  id: number;
  /** 年级 (如 "三年级") */
  grade: string;
  /** 班级名称 (如 "1班") */
  className: string;
  /** 排序号 (越小越靠前) */
  sortOrder: number;
  /** 归属教师用户ID */
  userId?: number;
  /** 创建时间 */
  addTime?: string;
  /** 创建人ID */
  addUserId?: number;
  /** 更新时间 */
  updateTime?: string;
  /** 更新人ID */
  updateUserId?: number;
}

@Injectable({ providedIn: "root" })
export class ClassService extends BaseService<ClassEntity> {
  constructor() {
    super("class");
  }

  /** 公开链接：获取某老师的班级列表（无需登录，供新生登记页下拉选择）。
   * 数据源是 class_info 表（班级字典），而非学生表已有班级。 */
  publicList(teacherId: number): Observable<ClassEntity[]> {
    return this.http
      .get<ClassEntity[]>(`${this.apiBaseUrl}/${this.apiPrefix}/publicList`, {
        params: new HttpParams().set("teacherId", String(teacherId)),
      })
      .pipe(map((res) => this.unwrap<ClassEntity[]>(res)));
  }
}
